import React from "react";
import Hero from "../components/aboutPage/hero/Hero";
import Why from "../components/aboutPage/why/Why";
import Mission from "../components/aboutPage/Mission/Mission";
import useSetTags from "../hooks/useSetTags";
import { CONFIG } from "../constants/TitleConfig";

const AboutPage = ({ data }) => {
  useSetTags(CONFIG)
  return (
    <>
      <Hero data={data.hero} />
      <Why data={data.why} />
      <Mission data={data.mission} />
    </>
  );
};

export default AboutPage;
